import { styled } from 'styled-components';

export const ModalContent = styled.div`
  padding: 0;
`;

export const Section = styled.div`
  ${({ theme }) => `
  margin-bottom: ${theme.marginLG}px;

  &:last-child {
    margin-bottom: 0;
  }
`}
`;

export const ConfigPreview = styled.div`
  ${({ theme }) => `
  background: ${theme.colorBgContainer};
  border: ${theme.lineWidth}px solid ${theme.colorBorder};
  border-radius: ${theme.borderRadius}px;
  padding: ${theme.paddingSM}px ${theme.padding}px;
  font-family: ${theme.fontFamilyCode};
  font-size: ${theme.fontSizeSM}px;
  max-height: ${theme.sizeXXL * 4.17}px;
  overflow-y: auto;
`}
`;

export const SchemaPreview = styled.div`
  ${({ theme }) => `
  background: ${theme.colorBgContainer};
  border: ${theme.lineWidth}px solid ${theme.colorBorder};
  border-radius: ${theme.borderRadius}px;
  padding: ${theme.paddingSM}px ${theme.padding}px;
  font-family: ${theme.fontFamilyCode};
  font-size: ${theme.fontSizeSM}px;
  max-height: ${theme.sizeXXL * 2}px;
  overflow-y: auto;
  white-space: pre-wrap;
`}
`;

export const SmallSecondaryText = styled.div`
  ${({ theme }) => `
  font-size: ${theme.fontSizeSM}px;
  display: block;
  color: ${theme.colorTextSecondary};
`}
`;
